import type { CSSProperties } from 'react';
import { layout } from '../../theme/tokens';
import { Wrapper, LeftSide, RightSide, ContentInner } from './SplitLayout.styles';
import type { SplitLayoutProps } from './SplitLayout.types';

export function SplitLayout({
  left,
  right,
  leftWidth = '58%',
  height = `calc(var(--layout-viewport-height, 100vh) - ${layout.headerHeightDesktop})`,
  contentMaxWidth = '480px',
  contentGap = '64px',
  mobileHorizontalPadding,
  flushRightContent = false,
  containedScroll = false,
  hideLeftOnMobile = false,
}: SplitLayoutProps) {
  const wrapperStyle = {
    '--split-height': height,
  } as CSSProperties;

  const leftStyle = {
    '--split-left-width': leftWidth,
  } as CSSProperties;

  const rightStyle = {
    '--split-right-width': `calc(100% - ${leftWidth})`,
  } as CSSProperties;

  const innerStyle = {
    '--split-content-max-width': contentMaxWidth,
    '--split-content-gap': contentGap,
  } as CSSProperties;

  return (
    <Wrapper style={wrapperStyle} data-contained-scroll={containedScroll ? '' : undefined}>
      <LeftSide style={leftStyle} $hideOnMobile={hideLeftOnMobile}>
        {left}
      </LeftSide>
      <RightSide
        style={rightStyle}
        $mobileHorizontalPadding={mobileHorizontalPadding}
        $flush={flushRightContent}
        $flushMobile={hideLeftOnMobile}
      >
        <ContentInner style={innerStyle}>{right}</ContentInner>
      </RightSide>
    </Wrapper>
  );
}
